import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import OfficeLocations from "./sections/OfficeLocations";
import InquiryForm from "./sections/InquiryForm";
import Onlineappointmentbooking from "./sections/Onlineappointmentbooking";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <OfficeLocations />
      <Onlineappointmentbooking />
      <InquiryForm />
      <Footer />
    </div>;
}